// removed by extract-text-webpack-plugin
module.exports = {"arrowDown":"ruxBh","menuWrapper":"_7kiVh","menuList":"_29ZzY","menuDivider":"xQ6ud","menuItem":"VYXdh"};


//////////////////
// WEBPACK FOOTER
// ./src/views/components/ArticleMenu/ArticleMenu.less
// module id = 837
// module chunks = 0